import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  Checkbox,
  FlexBox,
  JoonUIColor,
  QuestRoutine,
  SPACING,
  TextButton,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useSetTimeModalStore } from "./SetTimeModal"
import { useDateTime } from "./useDateTime"
import { SelectRow } from "../../../../components/selectRow/SelectRow"
import { ROUTINE_LABEL_KEYS } from "../questLabelKeys"
import { useAddEditQuestStore } from "../useAddEditQuestStore"

export const RoutineSelectButton = ({
  questRoutine,
  index,
}: {
  questRoutine: QuestRoutine
  index: number
}) => {
  const { routine, reminderTimeMap, setReminderTimeMap } =
    useAddEditQuestStore()
  const { onOpen: onOpenSetTimeModal } = useSetTimeModalStore()
  const { onRoutineClick } = useDateTime()
  const { t } = useTranslation()

  const onRemoveTimeClick = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation()
    setReminderTimeMap({})
  }

  return (
    <SelectRow
      key={index}
      onClick={(e) => onRoutineClick(e, questRoutine)}
      hideBorder
      showBorderBottom={questRoutine !== QuestRoutine.NIGHT}
    >
      <FlexBox direction="row" align="center" gap={SPACING.space2} wrap={false}>
        <Checkbox
          selected={routine === questRoutine}
          inputType="radio"
          name={questRoutine}
          onChange={() => {}}
          hideBorder
        />
        <Typography variant="bodySmallBold" textAlign="left">
          {t(ROUTINE_LABEL_KEYS[questRoutine])}
        </Typography>
      </FlexBox>
      <TextButton
        onClick={(e?: React.MouseEvent<HTMLButtonElement>) => {
          e?.stopPropagation()
          onOpenSetTimeModal(questRoutine)
        }}
        style={{
          width: "fit-content",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: SPACING.space1,
          padding: SPACING.space2,
        }}
      >
        <Typography
          variant="bodyXSmallBold"
          color={
            reminderTimeMap?.[questRoutine]?.length > 0
              ? JoonUIColor.text.primary
              : routine === questRoutine
                ? JoonUIColor.text.secondary
                : JoonUIColor.background.disabled
          }
          style={{ whiteSpace: "nowrap" }}
        >
          {reminderTimeMap?.[questRoutine]?.length > 0
            ? reminderTimeMap[questRoutine]
            : t("QUEST_SET_DUE_TIME")}
        </Typography>
        {routine === questRoutine &&
        reminderTimeMap?.[questRoutine]?.length > 0 ? (
          <TextButton onClick={onRemoveTimeClick} style={{ padding: 0 }}>
            <FontAwesomeIcon
              icon={faXmark}
              color={JoonUIColor.icon.neutral}
              size="lg"
            />
          </TextButton>
        ) : (
          <FontAwesomeIcon
            icon={faChevronRight}
            color={JoonUIColor.icon.neutral}
          />
        )}
      </TextButton>
    </SelectRow>
  )
}
